import { SvgIconProps, useTheme } from "@mui/material";
import React from "react";

export const SendIcon: React.FC<SvgIconProps> = (props) => {
  const { palette } = useTheme();

  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      xmlns="http://www.w3.org/2000/svg"
      fill={palette.mode === "dark" ? "white" : palette.common.black}
      {...props}
    >
      <path d="M0 22.6429V0.357178L24 11.5L0 22.6429ZM2.52632 18.4643L17.4947 11.5L2.52632 4.53575V9.41075L10.1053 11.5L2.52632 13.5893V18.4643Z" />
    </svg>
  );
};
